export default {
  coupon: {
    rules: '优惠券说明',
    myVoucher: '我的卡券包',
    OK: '兑换',
    redeemVoucher: '兑换',
    redeem: '兑换',
    cancelVoucher: '取消优惠券',
    expired: '已失效',
    unavailable: '不可用',
    nostart: '未开始',
    expiryDate: '有效期',
    entryvoucher: '请输入券码',
    over: '满 {money} 可用',
    coupon: '优惠券',
    cash: '充值券',
    Voucher: '抵用券',
    discountVoucher: '折扣券',
    email: '邮箱',
    businessPrepaidVoucher: '企业充值券',
	  prepaidVoucher: '普通充值券',
    voucherscode: '劵码',
    Minimumverbruik: '最低消费金额',
    freeshipping: '包邮券',
    有效范围: '有效范围',
	  '备注: 促销商品、秒杀商品、以及部分预售商品不在有效范围内': '备注: 促销商品、秒杀商品、以及部分预售商品不在有效范围内',
    cancelCash: '取消充值券',
    noExpired: '该充值劵可叠加使用，无失效时间',
    confirm: '确定',
    Details: '详情',
  }
}


// WEBPACK FOOTER //
// ./resources/js/lib/i18n/zh/coupon.js